import { ReactElement } from 'react';

import { Nullable } from '~globals/types';

import { DialogImportCustomersFromCSVProps } from './types';
import DialogImportCustomersFromCSVProvider, {
  useDialogImportCustomersFromCSVContext,
} from './Context';
import { DialogImportCustomersFromCSVContainer } from './styles';
import DialogImportCustomersFromCSVContent from './Content';

const DialogImportCustomersFromCSV = (): ReactElement => {
  const { open, onClose } = useDialogImportCustomersFromCSVContext();

  return (
    <DialogImportCustomersFromCSVContainer open={open} onClose={onClose}>
      <DialogImportCustomersFromCSVContent />
    </DialogImportCustomersFromCSVContainer>
  );
};

const WrapperDialogImportCustomersFromCSV = ({
  open,
  onClose,
  onSubmitSuccess,
  onUpdateErrors,
}: DialogImportCustomersFromCSVProps): Nullable<ReactElement> => {
  if (!open) return null;

  return (
    <DialogImportCustomersFromCSVProvider
      open={open}
      onClose={onClose}
      onSubmitSuccess={onSubmitSuccess}
      onUpdateErrors={onUpdateErrors}
    >
      <DialogImportCustomersFromCSV />
    </DialogImportCustomersFromCSVProvider>
  );
};

export default WrapperDialogImportCustomersFromCSV;
